/**
 * Firebase Configuration
 * 
 * This file contains all Firebase configuration including feature flags
 * and Firestore collection names.
 */

// Core Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyA0_VEmjwN_NT_-BCspj2GIX12JOhMc2B4",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "streamwarz-b00b5.firebaseapp.com",
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL || "https://streamwarz-b00b5-default-rtdb.firebaseio.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "streamwarz-b00b5",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "streamwarz-b00b5.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "55664342091",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:55664342091:web:dc9022b91b36eef4fe89ce",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-S0WRFMXN0C"
};

// Validate required environment variables
const requiredEnvVars = [
  'REACT_APP_FIREBASE_API_KEY',
  'REACT_APP_FIREBASE_AUTH_DOMAIN',
  'REACT_APP_FIREBASE_PROJECT_ID',
  'REACT_APP_FIREBASE_STORAGE_BUCKET',
  'REACT_APP_FIREBASE_MESSAGING_SENDER_ID',
  'REACT_APP_FIREBASE_APP_ID'
];

const missingEnvVars = requiredEnvVars.filter(envVar => !process.env[envVar]);

if (missingEnvVars.length > 0) {
  throw new Error(`Missing required environment variables: ${missingEnvVars.join(', ')}`);
}

// Feature flags
const FEATURE_FLAGS = {
  ENABLE_ANALYTICS: process.env.REACT_APP_ENABLE_ANALYTICS === 'true',
  ENABLE_PERFORMANCE_MONITORING: process.env.REACT_APP_ENABLE_PERFORMANCE_MONITORING === 'true',
  USE_EMULATORS: process.env.REACT_APP_USE_EMULATORS === 'true',
  APPCHECK_DEBUG_MODE: process.env.REACT_APP_APPCHECK_DEBUG_MODE === 'true'
};

// App Check configuration
const APP_CHECK_CONFIG = {
  siteKey: process.env.REACT_APP_RECAPTCHA_SITE_KEY,
  enableDebug: process.env.REACT_APP_APPCHECK_DEBUG_MODE === 'true'
};

// Firestore collection names
const COLLECTIONS = {
  USERS: 'users',
  STREAMERS: 'streamers',
  MATCHES: 'matches',
  TIERS: 'tiers',
  RANKINGS: 'rankings',
  STATS: 'stats',
  CONVERSATIONS: 'conversations',
  MESSAGES: 'messages'
};

// Rate limiting configuration
const RATE_LIMITS = {
  MAX_REQUESTS_PER_MINUTE: parseInt(process.env.REACT_APP_MAX_REQUESTS_PER_MINUTE || '60', 10),
  MAX_REQUESTS_PER_HOUR: parseInt(process.env.REACT_APP_MAX_REQUESTS_PER_HOUR || '1000', 10)
};

// Error handling configuration
const ERROR_CONFIG = {
  MAX_RETRIES: parseInt(process.env.REACT_APP_MAX_RETRIES || '3', 10),
  RETRY_DELAY: parseInt(process.env.REACT_APP_RETRY_DELAY || '1000', 10),
  TIMEOUT: parseInt(process.env.REACT_APP_TIMEOUT || '15000', 10)
};

// Security configuration
const SECURITY_CONFIG = {
  CORS_ORIGINS: [
    'https://streamwarz-b00b5.web.app',
    'https://streamwarz-b00b5.firebaseapp.com',
    'http://localhost:3000'
  ],
  ALLOWED_AUTH_PROVIDERS: ['google.com', 'email'],
  PASSWORD_MIN_LENGTH: 8,
  SESSION_TIMEOUT: 3600000, // 1 hour in milliseconds
  MAX_LOGIN_ATTEMPTS: 5,
  LOCKOUT_DURATION: 900000 // 15 minutes in milliseconds
};

// Emulator configuration
const EMULATOR_CONFIG = {
  firestore: {
    enabled: process.env.REACT_APP_FIRESTORE_EMULATOR_ENABLED === 'true',
    host: process.env.REACT_APP_FIRESTORE_EMULATOR_HOST || 'localhost',
    port: parseInt(process.env.REACT_APP_FIRESTORE_EMULATOR_PORT || '8080', 10)
  },
  auth: {
    enabled: process.env.REACT_APP_AUTH_EMULATOR_ENABLED === 'true',
    host: process.env.REACT_APP_AUTH_EMULATOR_HOST || 'localhost',
    port: parseInt(process.env.REACT_APP_AUTH_EMULATOR_PORT || '9099', 10)
  },
  functions: {
    enabled: process.env.REACT_APP_FUNCTIONS_EMULATOR_ENABLED === 'true',
    host: process.env.REACT_APP_FUNCTIONS_EMULATOR_HOST || 'localhost',
    port: parseInt(process.env.REACT_APP_FUNCTIONS_EMULATOR_PORT || '5001', 10)
  },
  storage: {
    enabled: process.env.REACT_APP_STORAGE_EMULATOR_ENABLED === 'true',
    host: process.env.REACT_APP_STORAGE_EMULATOR_HOST || 'localhost',
    port: parseInt(process.env.REACT_APP_STORAGE_EMULATOR_PORT || '9199', 10)
  }
};

// Add emulator config to firebaseConfig
firebaseConfig.emulators = EMULATOR_CONFIG;

// Export configurations
export {
  firebaseConfig,
  FEATURE_FLAGS,
  APP_CHECK_CONFIG,
  COLLECTIONS,
  RATE_LIMITS,
  ERROR_CONFIG,
  SECURITY_CONFIG,
  EMULATOR_CONFIG
}; 